import { render } from "./Gestionale.vue?vue&type=template&id=68571fc4"
import script from "./Gestionale.vue?vue&type=script&lang=js"
export * from "./Gestionale.vue?vue&type=script&lang=js"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__